export default "__VITE_ASSET__61c6c195__"